//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isBefore } from "date-fns";
import terms from "@/mixins/terms";

export default {
  mixins: [terms],

  props: {
    includeFixed: {
      type: Boolean,
      default: true,
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
  },
  jsonld() {
    const baseSchema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Main Navigation",
      itemListElement: [
        {
          "@type": "SiteNavigationElement",
          position: 1,
          name: "Business",
          description: "Business formation and management services",
          url: "https://www.legalnature.com/business",
          hasPart: [
            {
              "@type": "SiteNavigationElement",
              name: "Start a Business",
              description: "Professional formation services",
              url: "https://www.legalnature.com/business-formation/llc",
              hasPart: [
                {
                  "@type": "SiteNavigationElement",
                  name: "Start an LLC",
                  url: "https://www.legalnature.com/business-formation/llc",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Form a C-CORP",
                  url:
                    "https://www.legalnature.com/business-formation/c-corporation",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "File an S-CORP",
                  url:
                    "https://www.legalnature.com/business-formation/s-corporation",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Register a Nonprofit",
                  url:
                    "https://www.legalnature.com/business-formation/nonprofit",
                },
              ],
            },
            {
              "@type": "SiteNavigationElement",
              name: "Manage Your Business",
              description: "Keep your business compliant",
              url: "https://www.legalnature.com/business#manage",
              hasPart: [
                {
                  "@type": "SiteNavigationElement",
                  name: "Automated Compliance Management",
                  url: "https://www.legalnature.com/compliance-guard",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "BOI Report",
                  url:
                    "https://www.legalnature.com/categories/business-services/beneficial-ownership-information-report",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Registered Agent",
                  url: "https://www.legalnature.com/registered-agent",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Certificate of Good Standing",
                  url:
                    "https://www.legalnature.com/categories/business-services/certificate-of-good-standing",
                },
              ],
            },
            {
              "@type": "SiteNavigationElement",
              name: "Business Documents",
              description: "Professional formation services",
              url: "https://www.legalnature.com/business#documents",
              hasPart: [
                {
                  "@type": "SiteNavigationElement",
                  name: "LLC Operating Agreement",
                  url:
                    "https://www.legalnature.com/categories/business-formation/llc-operating-agreement",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Articles of Organization",
                  url:
                    "https://www.legalnature.com/categories/business-formation/articles-of-organization",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Non Disclosure Agreement",
                  url:
                    "https://www.legalnature.com/categories/human-resources/non-disclosure-agreement",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Contractor Agreement",
                  url:
                    "https://www.legalnature.com/categories/human-resources/Independent-Contractor-Agreement",
                },
              ],
            },
          ],
        },
        {
          "@type": "SiteNavigationElement",
          position: 2,
          name: "Personal",
          description: "Personal legal documents and estate planning",
          url: "https://www.legalnature.com/personal-affairs",
          hasPart: [
            {
              "@type": "SiteNavigationElement",
              name: "Estate Planner",
              description:
                "Secure your family's future with our top-tier legal documents",
              url: "https://www.legalnature.com/estate-planner",
              hasPart: [
                {
                  "@type": "SiteNavigationElement",
                  name: "Last Will",
                  url: "https://www.legalnature.com/estate-planner",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Living Trust",
                  url: "https://www.legalnature.com/estate-planner",
                },
              ],
            },
            {
              "@type": "SiteNavigationElement",
              name: "Power of Attorney",
              description: "Appoint a trusted person",
              url:
                "https://www.legalnature.com/categories/estate-planning/power-of-attorney",
              hasPart: [
                {
                  "@type": "SiteNavigationElement",
                  name: "General Power of Attorney",
                  url:
                    "https://www.legalnature.com/categories/estate-planning/power-of-attorney",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Medical Power of Attorney",
                  url:
                    "https://www.legalnature.com/categories/healthcare/medical-power-of-attorney",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Power of Attorney Revocation",
                  url:
                    "https://www.legalnature.com/categories/personal-affairs/revocation-poa",
                },
              ],
            },
            {
              "@type": "SiteNavigationElement",
              name: "Deeds",
              description: "Buy, sell, or transfer your real estate",
              url:
                "https://www.legalnature.com/categories/property/quit-claim-deed",
              hasPart: [
                {
                  "@type": "SiteNavigationElement",
                  name: "Quit Claim Deed",
                  url:
                    "https://www.legalnature.com/categories/property/quit-claim-deed",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "General Warranty Deed",
                  url:
                    "https://www.legalnature.com/categories/property/general-warranty-deed",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Property Deed",
                  url:
                    "https://www.legalnature.com/categories/property/property-deed",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Special Warranty Deed",
                  url:
                    "https://www.legalnature.com/categories/property/special-warranty-deed",
                },
              ],
            },
            {
              "@type": "SiteNavigationElement",
              name: "Other Documents",
              description: "Attorney crafted documents",
              url: "https://www.legalnature.com/personal-affairs",
              hasPart: [
                {
                  "@type": "SiteNavigationElement",
                  name: "General Affidavit",
                  url:
                    "https://www.legalnature.com/categories/personal-affairs/general-affidavit",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Bankruptcy Worksheet",
                  url:
                    "https://www.legalnature.com/categories/personal-affairs/bankruptcy-worksheet",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Cease and Desist",
                  url:
                    "https://www.legalnature.com/categories/personal-affairs/cease-and-desist-letter",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Prenuptial Agreement",
                  url:
                    "https://www.legalnature.com/categories/marriage-and-divorce/prenuptial-agreement",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Postnuptial Agreement",
                  url:
                    "https://www.legalnature.com/categories/marriage-and-divorce/postnuptial-agreement",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Affidavit of Marriage",
                  url:
                    "https://www.legalnature.com/categories/marriage-and-divorce/affidavit-of-marriage",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Cover Letter",
                  url:
                    "https://www.legalnature.com/categories/personal-affairs/cover-letter",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Mortgage Agreement",
                  url:
                    "https://www.legalnature.com/categories/property/mortgage-agreement",
                },
              ],
            },
          ],
        },
        {
          "@type": "SiteNavigationElement",
          position: 3,
          name: "Landlords",
          description: "Landlord and tenant management documents",
          url: "https://www.legalnature.com/real-estate",
          hasPart: [
            {
              "@type": "SiteNavigationElement",
              name: "Lease Preparation",
              description: "Streamline your lease preparation",
              url: "https://www.legalnature.com/real-estate",
              hasPart: [
                {
                  "@type": "SiteNavigationElement",
                  name: "Residential Rental Agreement",
                  url:
                    "https://www.legalnature.com/categories/landlord-and-tenant/residential-rental-agreement",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Lease Agreement",
                  url:
                    "https://www.legalnature.com/categories/landlord-and-tenant/lease-agreement",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Month to Month Rental Agreement",
                  url:
                    "https://www.legalnature.com/categories/landlord-and-tenant/month-to-month-rental-agreement",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Sublease Agreement",
                  url:
                    "https://www.legalnature.com/categories/landlord-and-tenant/residential-sublease-agreement",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Commercial Lease Agreement",
                  url:
                    "https://www.legalnature.com/categories/commercial-property/commercial-lease-agreement",
                },
              ],
            },
            {
              "@type": "SiteNavigationElement",
              name: "Tenancy Management",
              description: "For a good tenant relationship",
              url: "https://www.legalnature.com/real-estate",
              hasPart: [
                {
                  "@type": "SiteNavigationElement",
                  name: "Lease Amendment",
                  url:
                    "https://www.legalnature.com/categories/landlord-and-tenant/residential-lease-amendment",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Late Rent Notice",
                  url:
                    "https://www.legalnature.com/categories/landlord-and-tenant/late-rent-notice",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Rent Receipt",
                  url:
                    "https://www.legalnature.com/categories/landlord-and-tenant/rent-receipt",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Notice of Rent Increase",
                  url:
                    "https://www.legalnature.com/categories/landlord-and-tenant/notice-of-rent-increase",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Pet Addendum",
                  url:
                    "https://www.legalnature.com/categories/landlord-and-tenant/pet-addendum",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Commercial Lease Amendment",
                  url:
                    "https://www.legalnature.com/categories/commercial-property/commercial-lease-amendment",
                },
              ],
            },
            {
              "@type": "SiteNavigationElement",
              name: "Lease Termination",
              description: "End leases legally and smoothly",
              url: "https://www.legalnature.com/real-estate",
              hasPart: [
                {
                  "@type": "SiteNavigationElement",
                  name: "Eviction Notice",
                  url:
                    "https://www.legalnature.com/categories/landlord-and-tenant/eviction-notice",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Notice to Vacate",
                  url:
                    "https://www.legalnature.com/categories/landlord-and-tenant/notice-to-vacate",
                },
                {
                  "@type": "SiteNavigationElement",
                  name: "Lease Termination Agreement",
                  url:
                    "https://www.legalnature.com/categories/landlord-and-tenant/lease-termination",
                },
              ],
            },
          ],
        },
        {
          "@type": "SiteNavigationElement",
          position: 4,
          name: "Pricing",
          url: "https://www.legalnature.com/pricing",
        },
        {
          "@type": "SiteNavigationElement",
          position: 5,
          name: "Resources",
          url: "https://www.legalnature.com/resources",
        },
      ],
    };
    return baseSchema;
  },
  data() {
    return {
      env: "en",
      showFixed: false,
      is_auth_modal: false,
      isLogin: false,
      headerLocalFormType: "signup",
      newTermsModal: false,
    };
  },
  methods: {
    authSuccess() {
      this.is_auth_modal = false;
      if (this.userAcceptedTerms(this.profile, this.isAuthenticated))
        this.$router.push("/account");
      else this.newTermsModal = true;
    },
    acceptTermsSuccess() {
      this.$router.push("/account");
      this.newTermsModal = false;
    },
    handleDashboard() {
      if (this.isAuthenticated) {
        this.$router.push("/account");
      } else {
        this.headerLocalFormType = "login";
        this.showAuthModal();
      }
    },
    visibilityChanged(isVisible, entry) {
      this.showFixed = !isVisible;
    },
    showAuthModal() {
      this.is_auth_modal = true;
    },
    hideAuthModal() {
      this.is_auth_modal = false;
    },
  },
  watch: {
    isAuthenticated(newValue) {
      if (newValue === false) if (this.showSignUp) this.showAuthModal();
    },
  },
  computed: {
    profile() {
      return this.$store
        .$db()
        .model("profile")
        .query()
        .first();
    },
    isProfileLoaded() {
      return this.loadRequest ? this.loadRequest.isLoaded : false;
    },
    loadRequest() {
      return this.$store
        .$db()
        .model("requests")
        .find("profile");
    },
    showSignUp() {
      if (this.$route.query.signup) return true;
    },
    shouldLoadUser() {
      return this.$store.state.user.loading;
    },
    isAuthenticated() {
      if (this.profile) return this.profile.registered;
      else return false;
    },
  },
  mounted() {
    this.$store
      .$db()
      .model("profile")
      .getProfile();
  },
};
